import { render } from "./AdminAddUserB2B.vue?vue&type=template&id=64e32c0e&scoped=true"
import script from "./AdminAddUserB2B.vue?vue&type=script&lang=js"
export * from "./AdminAddUserB2B.vue?vue&type=script&lang=js"

import "./AdminAddUserB2B.vue?vue&type=style&index=0&id=64e32c0e&scoped=true&lang=css"

import exportComponent from "/home/u624473994/domains/backoffice.quickpay.pe/quickshop-admin-main/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-64e32c0e"]])

export default __exports__